import { useId } from 'react'
import type { Session, SessionPlace } from '../api/types'

export function folderOwner(session: Session): string | null {
  return session.place?.kind === 'checkout' ? null : session.place?.kind === 'existing' ? session.place.session : session.id
}

/** Only an issue's free folders on the chosen machine can be reused. */
export function issueWorktrees(sessions: readonly Session[], project: string | undefined, issue: string | undefined | null, runner: string | undefined, current?: string): Session[] {
  if (!issue) return []
  const occupied = new Set(sessions.filter(s => s.id !== current && s.state !== 'ended').map(folderOwner))
  for (const session of sessions) {
    const pending = session.pending_place
    if (session.id !== current && pending && pending.kind !== 'checkout') occupied.add(pending.kind === 'existing' ? pending.session : session.id)
  }
  const seen = new Set<string>()
  return sessions.filter(s => {
    const owner = folderOwner(s)
    if (s.id === current || !s.worktree_kept || s.project_id !== project || s.issue_id !== issue || s.runner_id !== runner || !owner || occupied.has(owner) || seen.has(owner) || !s.origin.base) return false
    seen.add(owner)
    return true
  })
}

export function FolderChoices({value, onChange, existing, disabled = false}: {value: SessionPlace; onChange: (place: SessionPlace) => void; existing: readonly Session[]; disabled?: boolean}) {
  const name = useId()
  return <fieldset className="code-dialog-where" disabled={disabled}>
    <legend>Where it runs</legend>
    <label className="code-choice"><input type="radio" name={name} checked={value.kind === 'worktree'} onChange={() => onChange({kind: 'worktree'})}/><span>A worktree of its own</span></label>
    {existing.length > 0 && <label className="code-choice"><input type="radio" name={name} checked={value.kind === 'existing'} onChange={() => onChange({kind: 'existing', session: existing[0]!.id})}/><span>The issue’s existing worktree</span></label>}
    {value.kind === 'existing' && <label className="field"><span>Worktree</span><select value={value.session} onChange={event => onChange({kind: 'existing', session: event.target.value})}>{existing.map(session => <option key={session.id} value={session.id}>{session.title ?? session.id}</option>)}</select></label>}
    <label className="code-choice"><input type="radio" name={name} checked={value.kind === 'checkout'} onChange={() => onChange({kind: 'checkout'})}/><span>The checkout<span className="code-choice-detail">Read only. Editing needs an issue worktree.</span></span></label>
  </fieldset>
}
